module.exports = __webpack_public_path__ + "static/media/radiobutton.8697470b.svg";